import React, { useEffect, useRef } from "react";
import "./assets/vendors/bootstrap/css/bootstrap.min.css";
import "./assets/vendors/animate/animate.min.css";
import "./assets/vendors/fontawesome/css/all.min.css";
import "./assets/vendors/jarallax/jarallax.css";
import "./assets/vendors/jquery-magnific-popup/jquery.magnific-popup.css";
import "./assets/vendors/nouislider/nouislider.min.css";
import "./assets/vendors/odometer/odometer.min.css";
import "./assets/vendors/swiper/swiper.min.css";
import "./assets/vendors/pifoxen-icons/style.css";
import "./assets/vendors/tiny-slider/tiny-slider.min.css";
import "./assets/vendors/owl-carousel/owl.carousel.min.css";
import "./assets/vendors/bxslider/jquery.bxslider.css";
import "./assets/vendors/bootstrap-select/css/bootstrap-select.min.css";
import "./assets/vendors/vegas/vegas.min.css";
import "./assets/vendors/jquery-ui/jquery-ui.css";
import "./assets/vendors/timepicker/timePicker.css";

import "./assets/css/pifoxen.css";
import "./assets/css/pifoxen-responsive.css";
import "./assets/custom-css/custom.css";
import Main from "./routes/Main";
import Header from "./components/Header";
import Menu from "./components/Menu";
import Footer from "./components/Footer";
import MobileNav from "./components/MobileNav";
import ScrollToTop from "./components/ScrollToTop";
import Loader from "./components/Loader";
import { Element } from "react-scroll";
import { fetchCompanyDetails } from "./api/CompanyDetailsApi";
import { dynamicFailed, dynamicSuccess } from "./hooks/useToast";
import { useCompanyDetailsContext } from "./context/CompanyDetailsContext";
import { useUserDataContext } from "./context/UserDataContext";
import { checkUser } from "./api/UserApi";
import AdminSideBar from "./components/AdminSideBar";
import MemberSideBar from "./components/MemberSideBar";
import UserMenu from "./components/UserMenu";
import { fetchMemberLists, getToken } from "./api/MemberApi";
import axios from "axios";
import { headers } from "./exports/exports";
import { useEventContext } from "./context/EventContext";
import { gapi } from "gapi-script";
import { useSubHeadingContext } from "./context/SubHeadingContext";
import { fetchSurgicalSubHeading } from "./api/SurgicalDomainApi";
import { useLoader } from "./context/LoaderContext";

const MainPage = () => {
  const { companyDetailsData, setCompanyDetailsData } =
    useCompanyDetailsContext();
  const { subHeadingData, setSubHeadingData } = useSubHeadingContext();
  const { userData, setUserData } = useUserDataContext();
  const { eventData } = useEventContext();
  const { setLoading } = useLoader();

  const tokenClientRef = useRef<any>(null);
  const CLIENT_ID =
    "972554341930-enjn5plgfm141560d9q5d443lofr23df.apps.googleusercontent.com";
  // const API_KEY = process.env.REACT_APP_eventApiKey
  const API_KEY = "AIzaSyAtCK3bpozKtK9f5Xa9xfbUyzbQKik1V14";
  useEffect(() => {
    Promise.all([fetchMemberLists(), getToken()])
      .then(async ([listMemberData, tokenData]) => {
        const today = new Date();
        const sisheaders = {
          Authorization: `Bearer ${tokenData[0]?.attributes?.Token}`,
        };

        const expiredMembers = listMemberData?.filter((user: any) => {
          const expiry = user.attributes.Membership_Expiry;
          if (!expiry) return false;
          const expiryDate = new Date(expiry);
          return expiryDate < today && user.attributes.Status !== "Expired";
        });

        for (const member of expiredMembers) {
          const locationDetail = {
            area_name: "Chhauni",
            street_name: "Kakancho Binayak Marg",
            nearest_landmark: "",
            municipalities_id: 332,
            district_id: 28,
            province_id: 3,
          };

          const res = await axios.post(
            `${process.env.REACT_APP_locationUrl}/location`,
            locationDetail,
            {
              headers: sisheaders,
            },
          );
          if (res?.status === 200 || res?.status === 201) {
            const userDetail = {
              name: member?.attributes?.First_Name,
              phone_no: member?.attributes?.Mobile_Number,
              address: JSON.stringify({
                area_name: { id: res?.data?.area_id },
                street_name: { id: res?.data?.street_id },
                nearest_landmark: "",
                municipalities_id: 332,
                district_id: 28,
                province_id: 3,
              }),
              email: member?.attributes?.Email,
              gender: member?.attributes?.Sex === "Male" ? 1 : 2,
              dob: "2000-01-01T00:00:00+05:45",
              //   password: password,
              //   password_confirmation: reenterPassword,
              status: 0,
              roles: ["member"],
              profile_pic: null,
            };
            const userUpRes = await axios.put(
              `${
                process.env.REACT_APP_IDENTITY_SERVER_URL
              }api/admin/users/${Number(member?.attributes?.sis_id)}`,
              userDetail,
              {
                headers: sisheaders,
              },
            );
            if (userUpRes?.data?.status === "success") {
              const data = {
                data: {
                  Status: "Expired",
                },
              };
              const message = {
                data: {
                  Message: "Your membership is expired.",
                  Type: "status",
                  bf_frcsit_user: member.id,
                },
              };

              try {
                await axios.put(
                  `${process.env.REACT_APP_strapiUrl}/api/frcsit-users/${member.id}`,
                  data,
                  {
                    headers: headers,
                  },
                );
                await axios.post(
                  `${process.env.REACT_APP_strapiUrl}/api/frcsit-notices`,
                  message,
                  { headers },
                );
              } catch (error) {
                console.error(`Failed to update user ID ${member.id}:`, error);
              }
            }
          }
        }
      })
      .catch(() => {
        dynamicFailed("Server Error");
      });
  }, []);
  useEffect(() => {
    if (companyDetailsData.length === 0) {
      Promise.all([fetchCompanyDetails()])
        .then(([CompanyDetailsData]) => {
          setCompanyDetailsData(CompanyDetailsData);
        })
        .catch(() => {
          dynamicFailed("Server Error");
        });
    }
  }, [companyDetailsData.length, setCompanyDetailsData]);
  useEffect(() => {
    if (subHeadingData.length === 0) {
      Promise.all([fetchSurgicalSubHeading()])
        .then(([SubHeadingData]) => {
          setSubHeadingData(SubHeadingData);
        })
        .catch(() => {
          dynamicFailed("Server Error");
        });
    }
  }, [setSubHeadingData, subHeadingData.length]);
  const accessToken = localStorage.getItem("frcsit:access-token");
  useEffect(() => {
    if (!userData) {
      if (accessToken === null || accessToken === undefined) {
        return;
      }
      Promise.all([checkUser(accessToken)])
        .then(([userData]) => {
          setUserData(userData);
        })
        .catch(() => {
          dynamicFailed("Server Error");
        });
    }
  }, [accessToken, setUserData, userData]);
  useEffect(() => {
    if (
      userData?.data?.roles[0]?.name !== "sa" ||
      !eventData ||
      eventData.length === 0 ||
      window.location.pathname !== "/admin/member-dashboard"
    )
      return;

    const calendarId =
      "bdf60c3eb90c74c76af2a8957b06ac167d8f5e8938ae717662c4c42eeaf38bdd@group.calendar.google.com";

    const syncGoogleCalendar = async () => {
      try {
        await new Promise((resolve) => gapi.load("client", resolve));
        await gapi.client.init({
          apiKey: API_KEY,
          discoveryDocs: [
            "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
          ],
        });

        tokenClientRef.current = google.accounts.oauth2.initTokenClient({
          client_id: CLIENT_ID,
          scope: "https://www.googleapis.com/auth/calendar.events",
          callback: async (tokenResponse: any) => {
            if (!tokenResponse?.access_token) {
              return;
            }

            gapi.client.setToken(tokenResponse);

            const googleEventsResponse = await gapi.client.calendar.events.list(
              {
                calendarId,
                maxResults: 2500,
                singleEvents: true,
                orderBy: "startTime",
              },
            );

            const googleEvents = googleEventsResponse.result.items || [];
            setLoading(true);

            for (const item of eventData) {
              const {
                event_name,
                from_date,
                to_date,
                start_time,
                end_time,
                event_ids,
                in_google_calendar,
              } = item;
              const eventId = item.id;
              const timeZone = "Asia/Kathmandu";

              const eventIdsArray: string[] = Array.isArray(event_ids)
                ? event_ids
                : [];
              const dates: string[] = [];
              let currentDate = new Date(from_date);
              const endDate = new Date(to_date);

              while (currentDate <= endDate) {
                dates.push(currentDate.toISOString().split("T")[0]);
                currentDate.setDate(currentDate.getDate() + 1);
              }

              const matchedEvents = googleEvents.filter((e: any) => {
                const googleEventBaseId = e.id.split("_")[0];
                return eventIdsArray.includes(googleEventBaseId);
              });

              if (in_google_calendar) {
                const newEventIds: string[] = [];

                for (const date of dates) {
                  const startDateTime = new Date(
                    start_time ? `${date}T${start_time}` : `${date}T00:00:00`,
                  );

                  let endDateTime: Date;
                  if (end_time) {
                    endDateTime = new Date(`${date}T${end_time}`);
                    if (endDateTime.getTime() === startDateTime.getTime()) {
                      endDateTime = new Date(
                        startDateTime.getTime() + 3 * 60 * 60 * 1000,
                      );
                    }
                  } else {
                    endDateTime = new Date(
                      startDateTime.getTime() + 3 * 60 * 60 * 1000,
                    );
                  }

                  // Prevent empty duration error
                  if (endDateTime.getTime() <= startDateTime.getTime()) {
                    dynamicFailed("Time cannot be from today to tomorrow");
                    continue;
                  }

                  const startIso = startDateTime.toISOString();
                  const endIso = endDateTime.toISOString();

                  const existingEvent = matchedEvents.find((e: any) => {
                    const eventStartDate = new Date(e.start?.dateTime || "")
                      .toISOString()
                      .split("T")[0];
                    return eventStartDate === date;
                  });

                  if (existingEvent) {
                    const isChanged =
                      existingEvent.start?.dateTime !== startIso ||
                      existingEvent.end?.dateTime !== endIso ||
                      existingEvent.summary !== event_name;

                    if (isChanged) {
                      await gapi.client.calendar.events.update({
                        calendarId,
                        eventId: existingEvent.id,
                        resource: {
                          summary: event_name,
                          start: { dateTime: startIso, timeZone },
                          end: { dateTime: endIso, timeZone },
                        },
                      });
                    }

                    newEventIds.push(existingEvent.id.split("_")[0]);
                  } else {
                    const insertResponse =
                      await gapi.client.calendar.events.insert({
                        calendarId,
                        resource: {
                          summary: event_name,
                          start: { dateTime: startIso, timeZone },
                          end: { dateTime: endIso, timeZone },
                        },
                      });

                    newEventIds.push(insertResponse.result.id.split("_")[0]);
                  }
                  if (from_date === to_date) break;
                }
                const toDeleteIds = eventIdsArray.filter(
                  (oldId) => !newEventIds.includes(oldId),
                );
                for (const id of toDeleteIds) {
                  const eventToDelete = googleEvents.find((e: any) =>
                    e.id.startsWith(id),
                  );
                  if (eventToDelete) {
                    await gapi.client.calendar.events.delete({
                      calendarId,
                      eventId: eventToDelete.id,
                    });
                  }
                }
                const idsChanged =
                  JSON.stringify(newEventIds.sort()) !==
                  JSON.stringify(eventIdsArray.sort());
                if (idsChanged) {
                  await axios.put(
                    `${process.env.REACT_APP_strapiUrl}/api/frcsit-events-events/${eventId}`,
                    { data: { Event_Ids: newEventIds } },
                    { headers },
                  );
                }
              } else {
                for (const matchedEvent of matchedEvents) {
                  await gapi.client.calendar.events.delete({
                    calendarId,
                    eventId: matchedEvent.id,
                  });
                }
                if (eventIdsArray.length > 0) {
                  await axios.put(
                    `${process.env.REACT_APP_strapiUrl}/api/frcsit-events-events/${eventId}`,
                    { data: { Event_Ids: null } },
                    { headers },
                  );
                }
              }
            }
            const allEventIdsInStrapi = eventData.flatMap((item: any) =>
              Array.isArray(item.attributes.Event_Ids)
                ? item.attributes.Event_Ids
                : [],
            );

            const unmatchedEvents = googleEvents.filter((e: any) => {
              const googleEventBaseId = e.id.split("_")[0];
              return !allEventIdsInStrapi.includes(googleEventBaseId);
            });

            for (const unmatched of unmatchedEvents) {
              await gapi.client.calendar.events.delete({
                calendarId,
                eventId: unmatched.id,
              });
            }
            setLoading(false);
            dynamicSuccess("Google Calendar updated successfully!");
          },
        });

        tokenClientRef.current.requestAccessToken();
      } catch (err) {
        console.error("Sync failed:", err);
      }
    };

    syncGoogleCalendar();
  }, [eventData, setLoading, userData]);

  const userPage =
    window.location.pathname.includes("admin/") ||
    window.location.pathname.includes("member/");
  const adminPaths = [
    "/admin/member-dashboard",
    "/admin/members",
    "/admin/affliliates",
    "/admin/members/edit",
  ];

  const memberPaths = ["/member/notice", "/member/profile"];

  const pathname = window.location.pathname;

  const admin = adminPaths.some((path) => pathname.includes(path));
  const member = memberPaths.some((path) => pathname.includes(path));
  return (
    <>
      {/* <body> */}
      <div className="page-wrapper">
        <Element name="toTop"></Element>
        <header className="main-header-two clearfix">
          <Header />
          {!userPage && <Menu />}
        </header>
        {userPage && <UserMenu />}
        <Main />
        {!userPage && <Footer />}
      </div>
      <MobileNav />
      {admin && <AdminSideBar />}
      {member && <MemberSideBar />}
      <ScrollToTop />
      {/* </body> */}
      <Loader />
    </>
  );
};

export default MainPage;
